import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { UserListComponent } from './pages/user-list/user-list.component';
import { MountpointListComponent } from './pages/mountpoint-list/mountpoint-list.component';
import { HeaderComponent } from './shared/header/header.component';
import { SideNavigationMenuComponent } from './shared/side-navigation-menu/side-navigation-menu.component';
import { LandingComponent } from './landing/landing/landing.component';
import { LayoutsComponent } from './shared/layouts/layouts.component';

import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { OAuthModule } from 'angular-oauth2-oidc';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './services/auth.interceptor';
import { AdminDashboardComponent } from './pages/admin-dashboard/admin-dashboard.component';
import { LicenseAdminComponent } from './pages/license-admin/license-admin.component';
import { AdminToolsComponent } from './pages/admin-tools/admin-tools.component';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { UserMountpointComponent } from './pages/user-mountpoint/user-mountpoint.component';
import { RtkBaseAnalyzerPageComponent } from './pages/rtk-base-analyzer/rtk-base-analyzer.component';
import { PpkDownloaderPageComponent } from './pages/ppk-downloader/ppk-downloader.component';
import { LicenseComponent } from './pages/license/license.component';
import { NtripCredentialComponent } from './pages/ntrip-credential/ntrip-credential.component';
import { NtripServerAdminComponent } from './pages/ntrip-server-admin/ntrip-server-admin.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { AddLicenseDialogComponent } from './pages/license-admin/add-license-dialog.component';
import { HelpDialogComponent } from './pages/help-dialog/help-dialog.component';
import { MountPointPopupComponent } from './pages/mount-point-popup/mount-point-popup.component';
import { ConfirmDialogComponent } from './pages/confirm-dialog/confirm-dialog.component';
import { AcknowledgeDialogComponent } from './pages/acknowledge-dialog/acknowledge-dialog.component';
import { LandingHeaderComponent } from './landing/landing-header/landing-header.component';
import { LandingFooterComponent } from './landing/landing-footer/landing-footer.component';
import { LandingAboutUsComponent } from './landing/landing-about-us/landing-about-us.component';
import { LandingLayoutsComponent } from './landing/landing-layouts/landing-layouts.component';
import { LandingContactUsComponent } from './landing/landing-contact-us/landing-contact-us.component';
import { LandingRefundPolicyComponent } from './landing/landing-refund-policy/landing-refund-policy.component';
import { LandingTermsConditionsComponent } from './landing/landing-terms-conditions/landing-terms-conditions.component';
import { LandingSecurityPrivacyComponent } from './landing/landing-security-privacy/landing-security-privacy.component';
import { LandingDataProcessingComponent } from './landing/landing-data-processing/landing-data-processing.component';
import { LandingDisclaimerComponent } from './landing/landing-disclaimer/landing-disclaimer.component';
import { LandingCopyrightComponent } from './landing/landing-copyright/landing-copyright.component';
import { LandingNtripCasterComponent } from './landing/landing-ntrip-caster/landing-ntrip-caster.component';
import { LandingHomeComponent } from './landing/landing-home/landing-home.component';
import { GeoAstraSoftwareComponent } from './landing/geoastra-software/geoastra-software.component';
import { GeoAstraGnssReceiversComponent } from './landing/geoastra-gnss-receivers/geoastra-gnss-receivers.component';
import { LandingPpkDownloaderComponent } from './landing/landing-ppk-downloader/landing-ppk-downloader.component';
import { LandingRtkBaseAnalyzerComponent } from './landing/landing-rtk-base-analyzer/landing-rtk-base-analyzer.component';
import { LandingWhatsNewComponent } from './landing/landing-whats-new/landing-whats-new.component';
import { LandingQuickStartComponent } from './landing/landing-quick-start/landing-quick-start.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { InactiveUsersAdminComponent } from './pages/inactive-users-admin/inactive-users-admin.component';
import { S3DataPurgeAdminComponent } from './pages/s3-data-purge-admin/s3-data-purge-admin.component';
import { ExternalMountpointConnectionsComponent } from './pages/external-mountpoint-connections/external-mountpoint-connections.component';
import { AddMpcDialogComponent } from './pages/external-mountpoint-connections/add-mpc-dialog.component';
import { PpkDownloaderProComponent } from './pages/ppk-downloader-pro/ppk-downloader-pro.component';
import { RtkBaseAnalyzerProComponent } from './pages/rtk-base-analyzer-pro/rtk-base-analyzer-pro.component';
import { RtkBaseAnalyzerHelpDialogComponent } from './pages/rtk-base-analyzer/rtk-base-analyzer-help-dialog/rtk-base-analyzer-help-dialog.component';
import { PpkDownloaderHelpDialogComponent } from './pages/ppk-downloader/ppk-downloader-help-dialog/ppk-downloader-help-dialog.component';
import { PpkDownloaderStartTimeHelpDialogComponent } from './pages/ppk-downloader/ppk-downloader-start-time-help-dialog/ppk-downloader-start-time-help-dialog.component';
import { DashboardHelpDialogComponent } from './pages/dashboard/dashboard-help-dialog/dashboard-help-dialog.component';
import { DashboardConnectHelpDialogComponent } from './pages/dashboard/dashboard-connect-help-dialog/dashboard-connect-help-dialog.component';
import { DashboardLiveConnectionHelpDialogComponent } from './pages/dashboard/dashboard-live-connection-help-dialog/dashboard-live-connection-help-dialog.component';
import { AccessGateComponent } from './pages/access-gate/access-gate.component';
import { SiteAccessAdminComponent } from './pages/site-access-admin/site-access-admin.component';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    UserListComponent,
    MountpointListComponent,
    HeaderComponent,
    SideNavigationMenuComponent,
    LandingComponent,
    LayoutsComponent,
    AdminDashboardComponent,
    LicenseAdminComponent,
    AdminToolsComponent,
    UserProfileComponent,
    UserMountpointComponent,
    HelpDialogComponent,
    MountPointPopupComponent,
    ConfirmDialogComponent,
    AcknowledgeDialogComponent,
    AddLicenseDialogComponent,
    LandingHeaderComponent,
    LandingFooterComponent,
    LandingAboutUsComponent,
    LandingLayoutsComponent,
    LandingContactUsComponent,
    LandingRefundPolicyComponent,
    LandingTermsConditionsComponent,
    LandingSecurityPrivacyComponent,
    LandingDataProcessingComponent,
    LandingDisclaimerComponent,
    LandingCopyrightComponent,
    LandingNtripCasterComponent,
    LandingHomeComponent,
    GeoAstraSoftwareComponent,
    GeoAstraGnssReceiversComponent,
    LandingPpkDownloaderComponent,
    LandingRtkBaseAnalyzerComponent,
    LandingWhatsNewComponent,
    LandingQuickStartComponent,
    RtkBaseAnalyzerPageComponent,
    PpkDownloaderPageComponent,
    LicenseComponent,
    NtripCredentialComponent,
    NtripServerAdminComponent,
    InactiveUsersAdminComponent,
    S3DataPurgeAdminComponent,
    ExternalMountpointConnectionsComponent,
    AddMpcDialogComponent,
    PpkDownloaderProComponent,
    RtkBaseAnalyzerProComponent,
    RtkBaseAnalyzerHelpDialogComponent,
    PpkDownloaderHelpDialogComponent,
    PpkDownloaderStartTimeHelpDialogComponent,
    DashboardHelpDialogComponent,
    DashboardConnectHelpDialogComponent,
    DashboardLiveConnectionHelpDialogComponent,
    AccessGateComponent,
    SiteAccessAdminComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    OAuthModule.forRoot(),
    FormsModule,
    MatTooltipModule,
    MatDialogModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSidenavModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideAnimationsAsync(),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
